import React, {Component} from 'react';
import facebook from "../../images/social-facebook.png";
import twitter from "../../images/social-twitter.png";
import linkedin from "../../images/social-linkedin.png";
import instagram from "../../images/social-instagram.png";
import "./Footer.css";

/**
 * Footer
 */
export default class Footer extends Component {

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        return (

            <div>
                <div className="layout about-footer">
                    <header>
                        <h1>About Sargento Foods Inc.</h1>
                        <p>Sargento Foods is a family-owned company that has been a leader in cheese for more than 60 years. Founded in 1953 in Plymouth, Wisconsin, Sargento created the world’s first successful pre-packaged sliced and shredded natural cheeses. Today, Sargento Foods is still based in Wisconsin, where they manufacture and market amazing shredded, sliced and snack natural cheese products. For more information, please visit <a href="https://www.sargento.com/" target="_blank" rel="noopener noreferrer">www.sargento.com</a>.</p>
                    </header>
                </div>
                <footer className="footer">
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/SargentoCheese" target="_blank" rel="noopener noreferrer">
                                <img src={facebook} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/SargentoCheese" target="_blank" rel="noopener noreferrer">
                                <img src={twitter} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/sargentocheese/" target="_blank" rel="noopener noreferrer">
                                <img src={instagram} alt=""/>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/sargento-foods" target="_blank" rel="noopener noreferrer">
                                <img src={linkedin} alt=""/>
                            </a>
                        </li>
                    </ul>
                </footer>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx